class RavenConfigError extends Error {
  constructor(message) {
    super();
    this.name = 'RavenConfigError';
    this.message = message;
  }
}
export default RavenConfigError;